import { z } from 'zod';

export const ProjectsNotificationBadgeModel = z.object({
  comment: z.object({ unread: z.number() }),
  workflow: z.object({ actionRequired: z.number() }),
});
